export default __webpack_public_path__ + "1a4f53e341f7ce287146460b374966a1.svg";